"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RippleWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var RippleWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tmargin: ", ";\n\tposition: relative;\n\toverflow: hidden;\n\ttransform: translate3d(0, 0, 0);\n\twidth: ", ";\n\theight: ", "; \n\t&:after {\n\t\tcontent: \"\";\n\t\tdisplay: ", ";\n\t\tposition: absolute;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tpointer-events: none;\n\t\tbackground-image: radial-gradient(circle, #000 10%, transparent 10.01%);\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-position: 50%;\n\t\ttransform: scale(10,10);\n\t\topacity: 0;\n\t\ttransition: transform .5s, opacity 1s;\n\t}\n\t&:active:after {\n\t\ttransform: scale(0,0);\n\t\topacity: .2;\n\t\ttransition: 0s;\n\t}\n"])), function (props) {
  return props.margin;
}, function (props) {
  return props.fixDimension.width;
}, function (props) {
  return props.fixDimension.height || props.size ? props.theme.buttons.fontSize[props.size] * 2 : '32px';
}, function (props) {
  return props.disabled && !props.isLoading ? 'none' : 'block';
});

exports.RippleWrapper = RippleWrapper;